module.exports = __webpack_public_path__ + "img/icon-sb-shop-more-160x106.2cd72ac.svg";